export function initAnchorNavOverflow() {
	const navs = document.querySelectorAll('.act-anchor-nav.is-style-pill');

	navs.forEach((nav) => {
		const scrollArea = nav.querySelector('[data-anchor-nav-scroll]');
		const list = scrollArea ? scrollArea.querySelector('ul') : null;
		const prevButton = nav.querySelector('[data-anchor-nav-control="prev"]');
		const nextButton = nav.querySelector('[data-anchor-nav-control="next"]');

		if (!scrollArea || !prevButton || !nextButton) {
			return;
		}

		const getScroller = () => {
			if (!list) {
				return scrollArea;
			}

			const wrapperOverflow = Math.max(scrollArea.scrollWidth - scrollArea.clientWidth, 0);
			const listOverflow = Math.max(list.scrollWidth - list.clientWidth, 0);

			return listOverflow > wrapperOverflow ? list : scrollArea;
		};

		const updateState = () => {
			const scroller = getScroller();
			const maxScrollLeft = Math.max(scroller.scrollWidth - scroller.clientWidth, 0);
			const hasOverflow = maxScrollLeft > 1;
			const atStart = scroller.scrollLeft <= 1;
			const atEnd = scroller.scrollLeft >= (maxScrollLeft - 1);

			nav.classList.toggle('is-overflowing', hasOverflow);
			nav.classList.toggle('is-overflow-left', hasOverflow && !atStart);
			nav.classList.toggle('is-overflow-right', hasOverflow && !atEnd);

			prevButton.disabled = !hasOverflow || atStart;
			nextButton.disabled = !hasOverflow || atEnd;
		};

		const scrollByStep = (direction) => {
			const scroller = getScroller();
			const amount = Math.max(Math.round(scroller.clientWidth * 0.65), 120);
			scroller.scrollBy({
				left: direction === 'next' ? amount : -amount,
				behavior: 'smooth',
			});
		};

		prevButton.addEventListener('click', () => {
			scrollByStep('prev');
		});

		nextButton.addEventListener('click', () => {
			scrollByStep('next');
		});

		scrollArea.addEventListener('scroll', updateState, { passive: true });
		if (list) {
			list.addEventListener('scroll', updateState, { passive: true });
		}
		window.addEventListener('resize', updateState);

		if ('ResizeObserver' in window) {
			const observer = new ResizeObserver(updateState);
			observer.observe(scrollArea);
			if (scrollArea.firstElementChild) {
				observer.observe(scrollArea.firstElementChild);
			}
		}

		window.requestAnimationFrame(updateState);
	});
}
